<template>
  <button
    type="button"
    class="ds-button ds-button--ghost ds-button--sm investigation-copy-button"
    :data-qa="dataQa"
    @click="copy"
  >
    <ds-icon name="doc" />
    {{ label }}
  </button>
</template>

<script>
import DsIcon from '@/components/ds/atoms/dsIcon/DsIcon.vue'
import { copyToClipboard } from './investigationFormat'

// Copies one payload — an endpoint URL, a request or response body — and says
// so for a moment afterwards, because a clipboard write has no other visible
// result.

const RESET_DELAY = 1800

export default {
  name: 'InvestigationCopyButton',
  components: { DsIcon },
  props: {
    text: {
      type: String,
      required: true,
    },
    dataQa: {
      type: String,
      required: true,
    },
  },
  data() {
    return { state: null, resetTimer: null }
  },
  computed: {
    label() {
      if (this.state === 'copied') return 'Gekopieerd'
      if (this.state === 'failed') return 'Niet gelukt'
      return 'Kopiëren'
    },
  },
  beforeUnmount() {
    clearTimeout(this.resetTimer)
  },
  methods: {
    async copy() {
      const copied = await copyToClipboard(this.text)
      this.state = copied ? 'copied' : 'failed'
      clearTimeout(this.resetTimer)
      this.resetTimer = setTimeout(() => {
        this.state = null
      }, RESET_DELAY)
    },
  },
}
</script>

<style lang="scss" scoped>
// Layout only; the button itself comes from the design system (styles/ds/).
.investigation-copy-button {
  margin-left: auto;
}
</style>
